var map = {
	"./DemoBasic-docs": 128,
	"./DemoBinding-docs": 132,
	"./DemoEvents-docs": 138,
	"./DemoLazyLoading-docs": 144,
	"./DemoSlots-docs": 147
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;


//////////////////
// WEBPACK FOOTER
// ./demo/components ^\.\/Demo.*\-docs$
// module id = 127
// module chunks = 1